// extracted by mini-css-extract-plugin
module.exports = {"title":"c6195","wrapper":"a0f66","project":"f1801","select":"_32597","project-data":"d636d","projectData":"d636d"};